export default __webpack_public_path__ + "static/media/googleCalendarIcon.f1ba406d.svg";